import scrollerSerkan from '@/assets/funnel35/stories/Serkan.webp';
import scrollerIngrid from '@/assets/funnel35/stories/Ingrid.webp';
import scrollerJames from '@/assets/funnel35/stories/James.webp';
import scrollerSilvina from '@/assets/funnel35/stories/Silvina.webp';
import scrollerSamir from '@/assets/funnel35/stories/Samir.webp';
import scrollerAnnelie from '@/assets/funnel35/stories/Annelie.webp';
import scrollerZoran from '@/assets/funnel35/stories/Zoran.webp';
import scrollerClaudia from '@/assets/funnel35/stories/Claudia.webp';
import scrollerMonique from '@/assets/funnel35/stories/Monique.webp';
import scrollerHan from '@/assets/funnel35/stories/Han.webp';
import avatar1 from '@/assets/funnel35/ra-stories-1.png';
import avatar2 from '@/assets/funnel35/avatar-2.jpg';
import avatar3 from '@/assets/funnel35/avatar-3.jpg';

export const SOCIAL_PROOF = {
  avatars: [avatar1, avatar2, avatar3],
  count: '10,500+',
  text: 'people landed remote jobs last month',
};

export const BENEFITS = [
  'Access thousands of remote jobs worldwide',
  'Get matched to best-fit jobs you’re most likely to land',
  'Auto-apply to jobs with resumes tailored to each role',
  'Ace any interview with live AI coach',
];

export const CTA = {
  subtext: 'Start a short quiz to find roles that truly fit your life.',
  button: 'Get my job matches now',
};

// Success stories for the marquee. Each card is a photo plus a caption drawn
// in code (name, bullet lines; optional background/textColor override the
// frosted white panel), so new stories only need a photo without baked text.
const PLACEHOLDERS = [
  scrollerSerkan, 
  scrollerAnnelie, 
  scrollerIngrid, 
  scrollerZoran, 
  scrollerJames, 
  scrollerClaudia, 
  scrollerSilvina, 
  scrollerMonique, 
  scrollerSamir, 
  scrollerHan
];

export const SUCCESS_STORIES = [
  {
    name: 'Serkan',
    lines: ['Got a remote job in 15 days', 'Software engineer at Airbnb', 'Salary: $210,000'],
  },
  {
    name: 'Annelie',
    lines: ['Got a remote job in 25 days', 'Customer support at Amazon', 'Salary: $82,000'],
  },
  {
    name: 'Ingrid',
    lines: ['Got a remote job in 29 days', 'Procurement at Bayer', 'Salary: $87,000'],
  },
  {
    name: 'Zoran',
    lines: ['Got a remote job in 19 days', 'Data scientist at Zillow', 'Salary: $185,000'],
  },
  {
    name: 'James',
    lines: ['Got a remote job in 24 days', 'Project coordinator at JLL', 'Salary: $127,000'],
  },
  {
    name: 'Claudia',
    lines: ['Got a remote job in 17 days', 'HR coordinator at Salesforce', 'Salary: $83,000'],
  },
  {
    name: 'Silvina',
    lines: ['Got a remote job in 31 days', 'Marketing manager at Nike', 'Salary: $151,000'],
  },
  {
    name: 'Monique',
    lines: ['Got a remote job in 33 days', 'SEO Specialist at HubSpot', 'Salary: $95,000'],
  },
  {
    name: 'Samir',
    lines: ['Got a remote job in 36 days', 'Financial advisor at Nuvant', 'Salary: $235,000'],
  },
  {
    name: 'Han',
    lines: ['Got a remote job in 25 days', 'Sales manager at Philips', 'Salary: $154,000'],
  },
].map((story, index) => ({ id: index + 1, image: PLACEHOLDERS[index % PLACEHOLDERS.length], ...story }));
